import * as types from './types';
import dayjs from 'dayjs';
// eslint-disable-next-line import/no-cycle
import { getInventoryDesc, transformPrice } from '@/lib/helper';
import { saasTypeMap, statusMap } from '@/lib/enum';
import api from '@/apis/manage/index';
import { last } from 'lodash';

const filterInitial = () => ({
  title: '',
  orderBy: '',
  pid: '',
  priceMin: '',
  priceMax: '',
  fromSaas: '',
  category: '',
  tagSort: [],
  tagID: '',
});

export default {
  namespaced: true,
  state: {
    filterForm: {
      ...filterInitial(),
    },
    loading: false,
    goodList: [],
    fetchGoodState: 'all',
    pageInfo: {
      size: 1,
      count: 10,
      total: 0,
    },
    guide: '',
    activeTabIndex: 0,
  },
  mutations: {
    setLoading(state, { loading }) {
      state.loading = loading;
    },
    [types.INIT_FILTER_FORM](state) {
      const filterForm = filterInitial();
      state.filterForm = {
        ...state.filterForm,
        ...filterForm,
      };
    },
    [types.SET_FILTER_FORM](state, form) {
      state.filterForm = {
        ...state.filterForm,
        ...form,
      };
    },
    [types.SET_GOOD_LIST](state, goodList) {
      state.goodList = goodList;
    },

    [types.SET_FETCH_GOOD_STATE](state, fetchGoodState) {
      state.fetchGoodState = fetchGoodState;
    },
    // 页码区域
    [types.INIT_PRODUCT_LIST_PAGE_INFO](state) {
      state.pageInfo = {
        ...state.pageInfo,
        size: 1,
        count: 10,
        total: 0,
      };
    },
    [types.SET_PRODUCT_LIST_PAGE_SIZE](state, size) {
      state.pageInfo.size = size;
    },
    [types.SET_PRODUCT_LIST_PAGE_COUNT](state, count) {
      state.pageInfo.count = count;
    },
    [types.SET_PRODUCT_LIST_PAGE_TOTAL](state, total) {
      state.pageInfo.total = total;
    },
    [types.RESET](state) {
      const filterForm = filterInitial();
      state.filterForm = {
        ...state.filterForm,
        ...filterForm,
      };

      state.fetchGoodState = 'all';

      this.dispatch('qq/goodListManage/fetchGoodList');
    },
    SHOW_GUIDE(state) {
      state.guide = Date.now();
    },
  },
  actions: {
    async fetchGoodList({ state, commit, rootState }) {
      const { qq } = rootState;
      const { media_id: mediaId } = qq.activeMedia;
      const { pageInfo, filterForm, fetchGoodState } = state;

      if (!mediaId) {
        commit(types.SET_GOOD_LIST, []);
        commit(types.SET_PRODUCT_LIST_PAGE_TOTAL, 0);
        return;
      }
      console.log('filterForm', filterForm);
      commit('setLoading', { loading: true });
      const reqData = {
        title: filterForm.title,
        saas_product_id: filterForm.pid,
        price: transformPrice(`${filterForm.priceMin},${filterForm.priceMax}`),
        source: filterForm.fromSaas,
        primary_cate: filterForm.category === '全部' ? '' : filterForm.category,
        media: 'qq',
        media_id: mediaId,
        status: fetchGoodState,
        order_by: filterForm.orderBy,
        page: pageInfo.size,
        count: pageInfo.count,
        tag_cat_id: last(filterForm.tagSort) ? Number(last(filterForm.tagSort)) : 0,
        tag_id: filterForm.tagID ? Number(filterForm.tagID) : 0,
        scene: 1, // 中台固定传1
      };
      api.queryProductList(reqData)
        .then((res) => {
          const code = res.head && res.head.code;
          if (code !== undefined && code !== 0) {
            // 接口业务层报错，请求库会自动处理
            return;
          }

          // 请求成功，处理数据
          const list = res.product_list || [];
          const tableData = list.map(item => ({
            ...item,
            statusDesc: statusMap[item.status].title,
            statusColor: statusMap[item.status].color,
            priceDesc: `¥${(item.price / 100).toFixed(2)}`,
            commissionRateDesc: `¥${(item.commission / 100).toFixed(2)} / ${Number(item.commission_rate)}%`,
            mtimeDesc: dayjs(item.mtime).format('YYYY-MM-DD HH:mm:ss'),
            saasTypeDesc: saasTypeMap[item.saas_type] || '',
            inventoryDesc: getInventoryDesc(item),
            // 上架按钮是否展示
            showPushUpBtn:
              item.status !== 'auditing'
              && item.status !== 'onsale'
              && item.status !== 'refuse',
            // 下架按钮是否展示
            showPushDownBtn: item.status === 'onsale',
            tagList: item.tags,
          }));
          commit(types.SET_GOOD_LIST, tableData);
          commit(types.SET_PRODUCT_LIST_PAGE_TOTAL, Number(res.paginfo.total));
        })
        .finally(() => {
          commit('setLoading', { loading: false });
        });
    },
  },
};
